import { BulkDeviceRegisterPage } from "fleet/view/device/bulk-register";
import { connect } from "react-redux";
import { deviceService } from "service/device";
import { socket } from "websocket";

function mapDispatchToProps(dispatch) {
  return {
    bulkRegisterDevices: (serviceArgs) => {
      return deviceService
        .bulkRegister(serviceArgs.file, socket.id)
        .then((resp) => resp.data.data);
    },
  };
}

const ConnectedBulkDeviceRegistrationPage = connect(
  null,
  mapDispatchToProps,
)(BulkDeviceRegisterPage);

export { ConnectedBulkDeviceRegistrationPage };
